export default __webpack_public_path__ + "2e637644b823079e4536c712b00df8bb.png";